import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export interface ICollaborationParms {
  className?: string
}

const useStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({

  boundingRect: {
    fill: '#d9f1fd',
    stroke: '#204284',
    strokeMiterLimit: '10',
    strokeWidth: '20px',
  },

  person: {
    // fill: theme.stylizedSvgIconGraphics.graphicsPrimaryColor,
    fill: '#204284',
  },

  connector: {
    fill: 'none',
    // stroke: theme.stylizedSvgIconGraphics.graphicsPrimaryColor,
    stroke: '#204284',
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
    strokeWidth: '21.39px',
  },

}));


// By wrapping this component's definition in React.forwardRef, we enable having the ability to accept a React.Ref (ref?) parameter, in addition to the 
// normal 'props' parameter collection. The 'ref' allows us to forward the embedded <svg> element as a DOM reference
const Collaboration = React.forwardRef((props: ICollaborationParms, ref?: React.Ref<SVGSVGElement>) => {

  const { className } = props;
  const classes: Record<string, string> = useStyles();

  return (
    <svg ref={ref} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520" >
      <defs>
      </defs>
      <g id="CollaborationIcon">

        <rect id="BorderAndBackground" className={classes.boundingRect} x="10" y="10" width="500" height="500" rx="10.44" ry="10.44" />

        <g id="People">
          <g id="Person_BottomLeft">
            <g id="Body">
              <path className={classes.person} d="M179.24,456.33c21.06-11.23,31.79-35.48,26.65-58.79l-4.51-20.49c-3.37-15.31-13.57-27.48-26.82-33.13-2.37-1.01-5.1-.04-6.69,1.99-10.69,13.64-24.86,23.42-42.25,23.42s-31.56-9.79-42.26-23.42c-1.59-2.03-4.32-3-6.69-1.99-13.25,5.66-23.44,17.83-26.81,33.13l-5.07,23c-4.99,22.67,4.73,46.67,25.09,57.82,24.95,13.66,63.02,23.18,109.36-1.54Z" />
            </g>
            <g id="Head">
              <path className={classes.person} d="M169.3,290.88c0,22.88-19.56,64.65-43.69,64.65s-43.69-41.77-43.69-64.65,19.56-41.42,43.69-41.42,43.69,18.54,43.69,41.42Z" />
            </g>
          </g>
          <g id="Person-BottomRight">
            <g id="Body-2" data-name="Body">
              <path className={classes.person} d="M448.42,456.41c21.06-11.23,31.79-35.48,26.65-58.79l-4.51-20.49c-3.37-15.31-13.57-27.48-26.82-33.13-2.37-1.01-5.1-.04-6.69,1.99-10.69,13.64-24.86,23.42-42.25,23.42s-31.56-9.79-42.26-23.42c-1.59-2.03-4.32-3-6.69-1.99-13.25,5.66-23.44,17.83-26.82,33.13l-5.07,23c-4.99,22.67,4.73,46.67,25.09,57.82,24.95,13.66,63.02,23.18,109.36-1.54Z" />
            </g>
            <g id="Head-2" data-name="Head">
              <path className={classes.person} d="M438.47,290.95c0,22.88-19.56,64.65-43.69,64.65s-43.69-41.77-43.69-64.65,19.56-41.42,43.69-41.42,43.69,18.54,43.69,41.42Z" />
            </g>
          </g>
          <g id="Person_Top">
            <g id="Body-3" data-name="Body">
              <path className={classes.person} d="M313.83,245.75c21.06-11.23,31.79-35.48,26.65-58.79l-4.51-20.49c-3.37-15.31-13.57-27.48-26.82-33.13-2.37-1.01-5.1-.04-6.69,1.99-10.69,13.64-24.86,23.42-42.25,23.42s-31.56-9.79-42.26-23.42c-1.59-2.03-4.32-3-6.69-1.99-13.25,5.66-23.44,17.83-26.82,33.13l-5.07,23c-4.99,22.67,4.73,46.67,25.09,57.82,24.95,13.66,63.02,23.18,109.36-1.54Z" />
            </g>
            <g id="Head-3" data-name="Head">
              <path className={classes.person} d="M303.88,80.3c0,22.88-19.56,64.65-43.69,64.65s-43.69-41.77-43.69-64.65,19.56-41.42,43.69-41.42,43.69,18.54,43.69,41.42Z" />
            </g>
          </g>
        </g>
        <g id="Connectors">
          <line className={classes.connector} x1="299.59" y1="347.15" x2="259.86" y2="331.04" />
          <polyline className={classes.connector} points="220.18 347.15 259.92 331.04 259.92 291.75" />
        </g>

      </g>

    </svg >
  )
});

export default Collaboration;
